import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { UserService } from '../../_services/user.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-activation',
    templateUrl: './activation.component.html',
    styleUrls: ['./activation.component.css'],
    standalone: false
})
export class ActivationComponent implements OnInit {

  token: string;
  loading = true;
  message: string = '';
  validated = false;

  private readonly UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.token = this.activatedRoute.snapshot.paramMap.get('token') ?? '';
  }

  ngOnInit() {
    // Guard: reject anything that isn't a valid UUID
    // (blocks .css.map and other browser asset requests from hitting the API)
    if (!this.UUID_REGEX.test(this.token)) {
      this.loading = false;
      this.router.navigateByUrl('/404');
      return;
    }

    // CRITICAL: Only call the activation API in the browser, NEVER on the SSR server.
    // The token is single-use. SSR would consume it, leaving nothing for the client,
    // causing the "token no longer valid" error even after successful activation.
    if (!isPlatformBrowser(this.platformId)) {
      // On the server: just keep loading state, let the browser handle it
      return;
    }

    this.userService.verify_sign_up_token(this.token).subscribe(
      (response) => {
        this.message = 'Your account has been successfully activated';
        this.validated = true;
        this.loading = false;
      },
      (error) => {
        this.message = 'The activation link is no longer valid';
        this.loading = false;
        setTimeout(() => this.router.navigateByUrl('/'), 5000);
      },
      () => {
        this.loading = false;
      }
    );
  }

  navigateToLogin(): void {
    this.router.navigate(['/signin']);
  }
}